// Single source of truth for budget category definitions.

/**
 * Seed data for all budget categories (id + display name).
 * Used by BudgetTracker to seed initial categories AND derived into
 * BUDGET_CALCULATOR_CATEGORIES so the two lists never drift apart.
 * Add new categories here; both the tracker and the calculator pick them up.
 */
export const DEFAULT_BUDGET_CATEGORY_SEEDS = [
  { id: 'venue', name: 'Venue' },
  { id: 'catering', name: 'Catering' },
  { id: 'photography', name: 'Photography' },
  { id: 'videography', name: 'Videography' },
  { id: 'fashion', name: 'Attire' },
  { id: 'music', name: 'Music / DJ' },
  { id: 'decor', name: 'Decorations' },
  { id: 'flowers', name: 'Flowers' },
  { id: 'asoebi', name: 'Asoebi & Fabrics' },
  { id: 'favors', name: 'Favors & Gifts' },
  { id: 'stationery', name: 'Invitations & Stationery' },
  { id: 'transportation', name: 'Transportation' },
  { id: 'accommodation', name: 'Accommodation' },
  { id: 'makeup', name: 'Hair & Makeup' },
  { id: 'rings', name: 'Rings & Jewelry' },
  { id: 'cake', name: 'Cake' },
  { id: 'officiant', name: 'Officiant' },
  { id: 'planning', name: 'Planning & Coordination' },
  { id: 'honeymoon', name: 'Honeymoon' },
  { id: 'other', name: 'Other' },
] as const;

/** Derived from seeds — do not edit this directly; update DEFAULT_BUDGET_CATEGORY_SEEDS instead. */
export const BUDGET_CALCULATOR_CATEGORIES: string[] = DEFAULT_BUDGET_CATEGORY_SEEDS.map(s => s.name);

/**
 * Maps a budget category id to the event categories it typically applies to.
 * Used to filter the Event dropdown in ProcurementOrderEdit.
 * An empty array means the category applies to ALL events.
 */
export const CATEGORY_EVENT_SCOPE: Record<string, string[]> = {
  venue:          ['Pre-Wedding', 'Traditional Wedding', 'Reception', 'Church Ceremony', 'Ceremony', 'After Party'],
  catering:       ['Pre-Wedding', 'Traditional Wedding', 'Reception', 'After Party'],
  photography:    ['Traditional Wedding', 'Reception', 'Church Ceremony', 'Ceremony', 'After Party'],
  videography:    ['Traditional Wedding', 'Reception', 'Church Ceremony', 'Ceremony', 'After Party'],
  fashion:        ['Traditional Wedding', 'Reception'],
  music:          ['Pre-Wedding', 'Traditional Wedding', 'Reception', 'After Party'],
  decor:          ['Pre-Wedding', 'Traditional Wedding', 'Reception', 'After Party'],
  flowers:        ['Traditional Wedding', 'Reception'],
  asoebi:         ['Traditional Wedding', 'Reception'],
  favors:         ['Traditional Wedding', 'Reception'],
  stationery:     [],
  transportation: [],
  accommodation:  [],
  makeup:         ['Traditional Wedding', 'Reception'],
  rings:          ['Reception', 'Church Ceremony', 'Ceremony'],
  cake:           ['Reception'],
  officiant:      ['Church Ceremony', 'Ceremony'],
  planning:       [],
  honeymoon:      [],
  other:          [],
};
